import React from "react";
import { useParams } from "react-router-dom";
import BarChart from "../../../components/chart/compare-chart";
import { ChurnCard } from "../../../components/card/card_churn";
import { ActiveSubscribersCard } from "../../../components/card/card_active_subscribers";
import { FailingSubscribersCard } from "../../../components/card/card_failing_subscribers";
import { NewSubscribersCard } from "../../../components/card/card_new_subscribers";
import { TotalSalesComparison } from "../../../components/total-sales-comparison";


const DashboardContainer = () => {

    let { subscriptionId } = useParams();

    return (
        <div className="container-fluid mt-4 m-md-5">
            <div className="row">
                <div className="col-lg-3 col-6 mb-5">
                    <div className="contentarea h-100 rounded-2">
                        <ActiveSubscribersCard />
                    </div>
                </div>
                <div className="col-lg-3 col-6 mb-5">
                    <div className="contentarea h-100 rounded-2">
                        <NewSubscribersCard />
                    </div>
                </div>
                <div className="col-lg-3 col-6 mb-5">
                    <div className="contentarea h-100 rounded-2">
                        <ChurnCard />
                    </div>
                </div>
                <div className="col-lg-3 col-6 mb-5">
                    <div className="contentarea h-100 rounded-2">
                        <FailingSubscribersCard />
                    </div>
                </div>
            </div>
            <div className="row align-items-stretch">
                <div className="col-12 mb-5">
                    <div className="contentarea d-flex p-5 flex-wrap min-h-300">
                        <div className="order-2 order-xl-1 w-75 outer-chart-container position-relative"><BarChart /></div>
                        <div className="order-1 order-xl-2 w-25 total-container position-relative d-flex flex-wrap d-xl-block"><TotalSalesComparison /></div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default DashboardContainer